//Dropdown taken from MUI - https://mui.com/material-ui/react-select/

import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Button, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// the drop down menu for selecting the table to sit at on landing page
export default function BasicSelect() {
  const [tableNo, setTableNo] = React.useState('');
  const [name, setName] = React.useState('');
  const [tables, setTables] = React.useState([]);
  const navigate = useNavigate();

  const handleChange = (event) => {
    setTableNo(event.target.value);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetch("/tables",
          {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
          }
        );
        const tables = await result.json();

        const newTables = [];
        for (let key in tables) {
          const pair = ["Table " + tables[key].number.toString() + " - " + tables[key].seats.toString() + " Seats", tables[key].number];
          newTables.push(pair);
        }
        setTables(newTables);
        
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []); 

const move = () => {
  navigate('/menu');
}

const submitTable = () => {

  const postData = async () => {
    try {
      const formData = {
        name: name,
        tableNumber: tableNo
      }
      const result = await fetch(`/customers/table?tableNumber=${tableNo}&name=${name}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }

        }
      );
      const customer = await result.json();

      localStorage.setItem('customerId', customer.id);
      localStorage.setItem('tableNo', tableNo);
      move();

    } catch (err) {
      console.log(err);
    }
  };
  postData();
}

  return (
    <Box sx={{ zIndex: 1 }}>    
    <FormControl fullWidth sx={{mt: 2, mb: 2}}>
      <TextField id="outlined-basic" label="Enter Name" variant="outlined" value={name} onChange={handleNameChange} />
    </FormControl>
      <FormControl fullWidth sx={{mb: 1, zIndex: 1}}>
        <InputLabel id="demo-simple-select-label">Select Table Number</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={tableNo}
          onChange={handleChange}
          displayEmpty
        >
            {tables.map((table) => (
              <MenuItem
                key={table[1]}
                value={table[1]}
              >
                {table[0]}
              </MenuItem>
            ))}
        </Select>
        <Button onClick={submitTable} variant='contained' sx={{mt: 2, mb: 1, backgroundColor: "black", color: "white",
              ':hover': {
                color: 'white',
                bgcolor: 'grey' }}}>Submit</Button>
      </FormControl>
    </Box>
  );
}